import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { JobsService }          from './transaction-center.jobs.service';
import { JobStatus }            from './transaction-center.jobs.status.filter.ajs';
import { JobStatusBooking }     from './transaction-center.jobs.status-booking.filter.ajs';
import { JobStatusBookingPipe } from './transaction-center.jobs.status-booking.pipe';
import { JobStatusPipe }        from './transaction-center.jobs.status.pipe';

angular.module('app-lite.transaction-center.jobs', [])
  .filter('jobStatus',        JobStatus)
  .filter('jobStatusBooking', JobStatusBooking)

  .service('jobsApi',              downgradeInjectable(JobsService))
  .service('jobStatusPipe',        downgradeInjectable(JobStatusPipe))
  .service('jobStatusBookingPipe', downgradeInjectable(JobStatusBookingPipe));
